import { render, staticRenderFns } from "./VisaType.vue?vue&type=template&id=3f123e20&"
import script from "./VisaType.vue?vue&type=script&lang=js&"
export * from "./VisaType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports